import { CLIENT_ID } from 'shared/constants';
import { AppPermission, UserInfo } from 'shared/types';

export const getAppPermissions = (InsightClaims: string) => {
    return InsightClaims.split(' ').filter((p) => p.startsWith(CLIENT_ID)) as AppPermission[];
};

export const getUserInfoFromIdClaims = ({
    given_name,
    family_name,
    name,
    email,
    sub,
    InsightClaims,
}: Record<string, string>): UserInfo => ({
    firstName: given_name,
    lastName: family_name,
    email,
    displayName: name,
    id: sub,
    insightClaims: InsightClaims,
});
